import { getImageQuality } from '../utils'

const configAggregator = (node) => {
    return {
        topHeading: node.getAttribute('data-w-top-heading'),
        heading: node.getAttribute('data-w-heading'),
        textColor: node.getAttribute('data-w-text-color'),
        image: node.getAttribute('data-w-image'),
        imageQuality: getImageQuality([]),
        isLink: node.getAttribute('data-w-is-link'),
        link: node.getAttribute('data-w-link'),
        contentPosition: node.getAttribute('data-w-content-position')
    }
}

export default configAggregator
